import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr className="tr-info">
                                <td colSpan={2} className="">
                                    <p className="text-left">
                                        <b>NNNN : </b>Serial Number starting from 0001
                                    </p>
                                </td>
                                <td colSpan={1} className="">
                                    <p className="text-right">
                                        Fill in <b>NA</b> if any field is not applicable
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w300">
                                    <p>Enquiry Reference</p>
                                </td>
                                <td className="hd-s1 pd10">
                                    <p />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">1.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Contract Clause</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.contract_clause.name}
                                        value={state.contract_clause.value}
                                        onChange={onChange}

                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">2.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Specification reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.specification_reference.name}
                                        value={state.specification_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">3.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Drawing No</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.drawing_number.name}
                                        value={state.drawing_number.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Classification Standards reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.classification_standard_reference.name}
                                        value={state.classification_standard_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">4.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>WPS reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.wps_refenrece.name}
                                        value={state.wps_refenrece.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">5.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Material Change</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.material_change.name}
                                        value={state.material_change.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">6.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Equipment List</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.equipment_list.name}
                                        value={state.equipment_list.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">7.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Site Query Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.site_query_refence.name}
                                        value={state.site_query_refence.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">8.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Inspection Comment Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.inspection_comment_reference.name}
                                        value={state.inspection_comment_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">9.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Approval Comment Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.approval_comment_reference.name}
                                        value={state.approval_comment_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">10.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Building Standards Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.building_standard_reference.name}
                                        value={state.building_standard_reference.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">11.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Meeting Minutes Reference</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.meeting_minute_refenrece.name}
                                        value={state.meeting_minute_refenrece.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">12.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Safety Issue</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.safety_issue.name}
                                        value={state.safety_issue.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">13.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Other (please specify)</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.other.name}
                                        value={state.other.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">14.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Location</p>
                                </td>
                                <td className="tb-input-value">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter here..."
                                        name={state.location.name}
                                        value={state.location.value}
                                        onChange={onChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="td-s1">
                                    <p className="s1">15.</p>
                                </td>
                                <td className="tb-input-value pl10">
                                    <p>Work to be stopped for corrective measure? </p>
                                </td>
                                <td className="tb-input-value">
                                    <select
                                        className="form-control"

                                        name={state.work_to_be_stopped_for_corrective_measure.name}
                                        value={state.work_to_be_stopped_for_corrective_measure.value}
                                        onChange={onChange}
                                    >
                                        <option value={''}>Yes/ NO</option>
                                        <option value={'Yes'}>Yes</option>
                                        <option value={'No'}>No</option>

                                    </select>
                                </td>
                            </tr>
                            <tr className="tr-info">
                                <td colSpan={2} className="">
                                    <p className="text-left" style={{ color: "rgb(0, 119, 226)" }}>
                                        Give reference to one or more as above{" "}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b">
                                            <p>DESCRIPTION</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <textarea
                                                name={state.description.name}
                                                value={state.description.value}
                                                onChange={onChange}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <table className="mrt10">
                                <tbody>
                                    <tr>
                                        <td className="hd-b" colSpan={5}>
                                            <p>VERIFIED by Site Team as below</p>
                                            <p />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5} className="input-textarea">
                                            <textarea
                                               disabled
                                            />
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box">
                                        <td className="input-td">
                                            <p className="s2">Signature of Site Manager</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                    disabled
                                                />
                                            </p>
                                        </td>
                                        <td className="w50" />
                                        <td className="input-td">
                                            <p className="s2">DATE</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                    disabled

                                                />
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6">
                            <table className="mrt10">
                                <tbody>
                                    <tr>
                                        <td className="hd-b" colSpan={5}>
                                            <p>SHIPYARD REPLY</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea" colSpan={5}>
                                            <textarea defaultValue={""}
                                                disabled

                                            />
                                        </td>
                                    </tr>
                                    <tr className="bottom-sig-tr2-box mrt10">
                                        <td className="input-td" >
                                            <p className="s2">Signature of Site Manager</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                    disabled

                                                />
                                            </p>
                                        </td>
                                        <td className="w50" />
                                        <td className="input-td">
                                            <p className="s2">DATE</p>
                                        </td>
                                        <td>
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    defaultValue=""
                                                    disabled

                                                />
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="final-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                            <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)